import { useSelector } from "react-redux";
import {
  getCouponsAsList,
  getPromotionsAsList,
  getReferralDiscount,
} from "pages/home/store";
import { AppSettings } from "../settings";

export const useOffers = () => {
  const coupons = useSelector(getCouponsAsList);
  const promotions = useSelector(getPromotionsAsList);
  const referral_discount = useSelector(getReferralDiscount);

  let price = 0;

  const [promotion] = promotions;
  const basePrice = AppSettings.priceReport;

  const calculatePrice = (discount) => basePrice - basePrice * (discount / 100);

  //if !referral && !promotion -> precioBase
  if (!referral_discount && !promotion) {
    price = basePrice;
  }
  //if referral && !promotion  -> descontar % referral al precioBase
  if (referral_discount && !promotion) {
    const { idar } = referral_discount;
    price = calculatePrice(idar?.complete);
  }
  //if !referral && promotion  -> descontar % promotion al precioBase
  if (!referral_discount && promotion) {
    price = calculatePrice(promotion.descuento);
  }
  //if referral && promotion   -> descontar % del mayor entre referral y promotion al precioBase
  if (referral_discount && promotion) {
    const { idar } = referral_discount;
    price =
      idar?.complete > promotion?.descuento
        ? calculatePrice(idar?.complete)
        : calculatePrice(promotion?.descuento);
  }

  return {
    coupons,
    hasDoublePromotion: referral_discount && promotion ? true : false,
    promotions,
    price,
    offerPrice: !promotion
      ? AppSettings.priceReport
      : AppSettings.priceReport -
        AppSettings.priceReport * (promotion.descuento / 100),
  };
};
